import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { safeNext } from "@/components/SocialSignIn";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback({ provider }) {
  const { socialLogin, refreshUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const linkGoogle = async (sessionId) => {
      try {
        await api.post("/auth/google/link", { session_id: sessionId });
        toast.success("Google is now connected");
      } catch (e) {
        toast.error(formatApiErrorDetail(e.response?.data?.detail));
      }
      await refreshUser();
      navigate("/settings", { replace: true });
    };
    const run = async () => {
      if (provider === "google") {
        const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
        window.history.replaceState(null, "", location.pathname);
        if (location.pathname === "/settings") return linkGoogle(sessionId);
        const result = await socialLogin("/auth/google/session", { session_id: sessionId });
        navigate(result.success ? location.pathname : "/login?error=google", { replace: true });
        return;
      }
      const params = new URLSearchParams(location.search);
      const result = await socialLogin("/auth/apple/exchange", { code: params.get("code") });
      navigate(result.success ? safeNext(params.get("next")) : "/login?error=apple", { replace: true });
    };
    run();
  }, [provider, location, navigate, socialLogin, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--brand-bg)]" data-testid="auth-callback">
      <p className="font-display text-lg text-muted-foreground italic">Signing you in...</p>
    </div>
  );
}
